import type { Player } from '../../../types/player';
import { normalizeText, teamAliases } from '../../../utils/teams';

function matchesQuery(player: Player, query: string): boolean {
  if (!player.name) return false;
  const q = normalizeText(query);
  if (!q) return true;
  const positionQuery = q === 'dst' || q === 'd/st' ? 'def' : q;
  if (player.position.toLowerCase() === positionQuery) return true;
  const n = normalizeText(player.name);
  if (n.includes(q)) return true;
  if (player.position === 'DEF') {
    const aliases = teamAliases(player.team);
    if (aliases.some((alias) => alias && (alias.includes(q) || q.includes(alias)))) return true;
  }
  return n.split(' ').some((token) => token.startsWith(q));
}

export function filterTradePool(pool: Player[], query: string): Player[] {
  return pool
    .filter((player) => matchesQuery(player, query))
    .sort((a, b) => {
      const rankA = a.rank && a.rank > 0 ? a.rank : 9999;
      const rankB = b.rank && b.rank > 0 ? b.rank : 9999;
      if (rankA !== rankB) return rankA - rankB;
      return (b.value || 0) - (a.value || 0);
    });
}

export function searchPlayers(pool: Player[], query: string): Player[] {
  if (query.trim().length < 2) return [];
  return filterTradePool(pool, query)
    .sort((a, b) => (b.value || 0) - (a.value || 0))
    .slice(0, 10);
}


